/**
 * Limits the number of times a function is called by delaying its execution until a certain interval of time
 * has passed since the last time it was called. This is useful for optimizing performance and preventing
 * unnecessary function calls.
 *
 * — The debounced function will only execute once, even if it is called multiple times within the
 * specified interval.
 * — The debounced function will execute with the last set of arguments passed to it.
 *
 * @param {Function} func     The function to debounce
 * @param {Integer}  interval The interval, in milliseconds
 * @return {Function}         The function debounced
 */
const debounce = ( func, interval = 300 ) => {
	let timer;

	return ( ...args ) => {
		clearTimeout( timer );

		timer = setTimeout( () => {
			func.apply( this, args );
		}, interval );
	};
};

export default debounce;
